'use client'

import { cn } from '@src/utils/tailwind'

interface PasswordRuleProps {
  isValid: boolean
  content: string
  hasErrors: boolean
}

export const PasswordRule = (props: PasswordRuleProps) => {
  const { content, hasErrors, isValid } = props

  return (
    <div className="flex items-center gap-3">
      <div
        className={cn('size-2 rounded-full bg-bodi-gray-light', {
          'bg-bodi-green-deep-500': isValid,
          'bg-bodi-red-deep-500': hasErrors && !isValid,
        })}
      ></div>
      <p
        className={cn('text-body-xs', {
          'text-bodi-red-deep-500': hasErrors && !isValid,
        })}
      >
        {content}
      </p>
    </div>
  )
}
